import axios from 'axios';
import API from '../../../src/config_api'
import { FETCH_NOTIFICATION_DATA_REQUEST, FETCH_NOTIFICATION_DATA_SUCCESS, FETCH_NOTIFICATION_DATA_FAILURE } from './NotificationTypes'
export const fetchDataRequest = () => {
    return {
        type: FETCH_NOTIFICATION_DATA_REQUEST
    }
}
export const fetchDataSuccess = data => {
    return {
        type: FETCH_NOTIFICATION_DATA_SUCCESS,
        payload: data
    }
}
export const fetchDataFailure = error => {
    return {
        type: FETCH_NOTIFICATION_DATA_FAILURE,
        payload: error
    }
}

export const fetchData = () => {
    return (dispatch) => {
        dispatch(fetchDataRequest());
        let formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'))
        axios({
                method: 'post',
                url: API.Notification,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
            .then(res => {
                if (res.data.status === 'success') {
                    const data = res.data;
                    console.log(res.data);
                    dispatch(fetchDataSuccess(data))

                } else {
                    const error = res.data.message;
                    dispatch(fetchDataFailure(error))
                }
            });
    }
}